import {
  Navigation,
  NavigationHamburger,
  useNavigationToggle,
} from "@coherence-design-system/navigation";
import React, { useEffect } from "react";
import { INavigationComponentProps } from "./NavigationComponent.types";
import { appInsights } from "../../services/Logging/AppInsights";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { useLocalStorageContext } from "../../Provider/LocalStorageProvider";
import { getUserRoles } from "../../Utils/UserAuthorization";
import { Stack } from "@fluentui/react";
import { getNavigationStyles } from "./NavigationComponent.styles";
import { UserRoles } from "../../common/enum/UserRoles";

const _isSelected = (location: Location, path: string): boolean => {
  const locationPath = location.protocol + "//" + location.host + "/#" + path;
  // console.log("location", location.href, locationPath);
  return location.href === locationPath;
};
export const NavigationComponent: React.FunctionComponent<
  INavigationComponentProps
> = (props: INavigationComponentProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const appInsights = useAppInsightsContext();
  const { isUserSignedIn, userRole, setUser } = useLocalStorageContext();
  const { isNavCollapsed, toggleNavCollapsed } = props;
  //   const { isNavCollapsed, toggleNavCollapsed } = useNavigationToggle();

  useEffect(() => {
    const handleUrlChange = () => {
      if (isUserSignedIn && window.location.hash === `#${location.pathname}`) {
        getUserRoles(isUserSignedIn, setUser);
      }
    };

    handleUrlChange();

    const unblock = () => handleUrlChange();

    return () => {
      unblock();
    };
  }, [location.pathname]);
  const groups = [
    {
      key: "Left navigantion menu",
      links: [
        {
          name: "Home",
          icon: "Home",
          key: "home_navigation",
          ariaLabel: "Home",
          // href: "#",
          "data-id": "automation_id_home",
          onClick: () => {
            appInsights.trackEvent({
              name: "In AppNavigation.tsx, clicked on Home under left navigation menu.",
            });
            navigate("/");
          },
          isSelected: _isSelected(window.location, "/"),
        },
        {
          name: "Customers",
          icon: "Contact",
          key: "customer_navigation",
          ariaLabel: "Customers",
          // href: "/Customers",
          // unicode: "\uE77B",
          onClick: () => {
            appInsights.trackEvent({
              name: "In AppNavigation.tsx, clicked on Customer under left navigation menu.",
            });
            navigate("/Customer");
          },
          isSelected: _isSelected(window.location, "/Customer"),
        },
        {
          name: "Quotations",
          icon: "TextDocument",
          key: "quotation_navigation",
          ariaLabel: "Quotations",
          // href: "/AllQuotations",
          onClick: () => {
            navigate("/AllQuotations");
          },
          isSelected: _isSelected(window.location, "/AllQuotations"),
        },
        {
          name: "Country Profile",
          icon: "Globe",
          key: "country_navigation",
          ariaLabel: "Country Profile",
          // href: "/CountryProfile",
          onClick: () => {
            console.log("From Countries");
            navigate("/CountryProfile");
          },
          isSelected: _isSelected(window.location, "/CountryProfile"),
        },
        {
          name: "Access Request",
          icon: "Permissions",
          key: "access_navigation",
          ariaLabel: "Access Request",
          // href: "/AccessRequest",
          onClick: () => {
            navigate("/AccessRequest");
          },
          isSelected: _isSelected(window.location, "/AccessRequest"),
        },
        ...(userRole === UserRoles.Manager || userRole === UserRoles.Admin ? [{
          name: "Quote Processing Metrics",
          icon: "BarChartVertical",
          key: "quote_processing_metrics_navigation",
          ariaLabel: "Quote Processing Metrics",
          onClick: () => {
            appInsights.trackEvent({
              name: "In NavigationComponent.tsx, clicked on QuoteProcessingMetrics under left navigation menu.",
            });
            navigate("/QuoteProcessingMetrics");
          },
          isSelected: _isSelected(window.location, "/QuoteProcessingMetrics"),
        }] : []),
      ],
    },
  ];

  const navigationStyles = getNavigationStyles(isNavCollapsed);

  return (
    <>
      <Stack>
        <Navigation
          styles={navigationStyles}
          groups={groups}
          isNavCollapsed={isNavCollapsed}
          toggleNavCollapsed={toggleNavCollapsed}
        />
      </Stack>
    </>
  );
};
